module.exports = __webpack_public_path__ + "img/_magic_.76f9662f.svg";